import React from 'react';
import { Navigate } from 'react-router-dom';
import { isUserRole } from '../../utils/jwt';

// For routes that can only be accessed by salesperson users
const SalespersonGuard = ({ children }) => {
  const role = isUserRole();

  // Allow both salesperson and admin users to access salesperson routes
  if (role !== 'salesperson' && role !== 'admin') {
    return <Navigate to={`/${role}`} />;
  }

  return children;
};

export default SalespersonGuard;
